import React, { useState } from "react";
import ArrowRightIcon from "@/assets/icons/arrow-right.svg";
import { Button } from "@/app/(components)/Basic/Button";
import { Nft } from "@/api/nfts/types";

import { NftOfferModal } from "../../../Nft/NftOfferModal";
import WalletIcon from "@/assets/icons/wallet.svg";
import { isEqual } from "@/shared/string";
import useWithCorrectNetwork from "@/shared/hooks/useWithCorrectNetwork";
import { useSuccessModal } from "@/app/(components)/Basic/SuccessModal/context/context";
import useMe from "@/shared/hooks/useMe";

export interface Props {
  nft: Nft;
  disable?: boolean;
}

export default function MakeOfferButton({ nft, disable }: Props) {
  const { me } = useMe();

  const { setSuccessData } = useSuccessModal();

  const [isMakeOfferConfirm, setIsMakeOfferConfirm] = useState<boolean>(false);

  const checkedOpenMakeOffer = useWithCorrectNetwork(() =>
    setIsMakeOfferConfirm(true),
  );

  const onClose = () => {
    setIsMakeOfferConfirm(false);
  };

  const onSuccess = async () => {
    await setSuccessData({
      title: "Create offer",
      item: {
        name: nft.name,
        media: nft.thumbnail!,
        mediaWidth: nft.imageWidth,
        mediaHeight: nft.imageHeight,
        mediaType: nft.mediaType,
        placeholder: nft.placeholder,
      },
      text: "Your offer is successfully submitted",
      buttonText: "View offers",
      redirectUrl: `/nft/${nft.id}/offers`,
    });

    onClose();
  };

  return (
    <>
      <Button
        disabled={isEqual(nft.owner.address, me?.address) || disable}
        onClick={checkedOpenMakeOffer}
        className="-bottom-20 mt-10 lg:mt-0 lg:absolute"
        startIcon={<WalletIcon />}
        endIcon={<ArrowRightIcon className="w-4" />}
      >
        Make offer
      </Button>
      {isMakeOfferConfirm ? (
        <NftOfferModal
          nft={nft}
          onSuccess={onSuccess}
          onClose={() => setIsMakeOfferConfirm(false)}
        />
      ) : null}
    </>
  );
}
